import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { addonMetadata } from '../../utils/planHelpers';

const DIMENSION_LABEL_KEY = {
  bots: 'downgradeModal.dimensionBots',
  numeros: 'downgradeModal.dimensionNumeros',
  seats: 'downgradeModal.dimensionSeats',
};

export default function DowngradeConfirmModal({ isOpen, onClose, prorrateo, blocked, loadingPreview, processing, onConfirm }) {
  const { t } = useTranslation('billing');
  const { t: tc } = useTranslation('common');

  if (!isOpen) return null;

  const handleConfirm = async () => {
    await onConfirm();
    onClose();
  };

  const renderBody = () => {
    if (loadingPreview) {
      return <p>{t('downgradeModal.calculating')}</p>;
    }

    if (blocked) {
      return (
        <div className="downgrade-blocked">
          {blocked.usageViolations.length > 0 && (
            <div className="downgrade-violation-group downgrade-violation-usage">
              <p className="downgrade-violation-title">{t('downgradeModal.usageViolationsTitle')}</p>
              <ul>
                {blocked.usageViolations.map((v) => (
                  <li key={v.dimension}>
                    {t('downgradeModal.usageViolationItem', {
                      label: t(DIMENSION_LABEL_KEY[v.dimension] || v.dimension),
                      used: v.used,
                      max: v.max,
                    })}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {blocked.addonViolations.length > 0 && (
            <div className="downgrade-violation-group downgrade-violation-addons">
              <p className="downgrade-violation-title">{t('downgradeModal.addonViolationsTitle')}</p>
              <ul>
                {blocked.addonViolations.map((v) => (
                  <li key={v.addonId}>
                    {v.reason === 'not_allowed'
                      ? t('downgradeModal.addonNotAllowed', { name: addonMetadata[v.addonId]?.name || v.addonId, qty: v.qty })
                      : t('downgradeModal.addonQtyExceeded', { name: addonMetadata[v.addonId]?.name || v.addonId, qty: v.qty, max: v.max })}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      );
    }

    if (!prorrateo) return null;

    return (
      <p>
        <Trans
          t={t}
          i18nKey="downgradeModal.message"
          values={{ amount: prorrateo.monto, currency: prorrateo.moneda }}
          components={{ strong: <strong /> }}
        />
      </p>
    );
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content cancel-addon-modal" onClick={e => e.stopPropagation()}>
        <h3>{t('downgradeModal.title')}</h3>
        {renderBody()}
        <div className="modal-actions">
          {!blocked && (
            <button
              className="btn-cancel-confirm"
              onClick={handleConfirm}
              disabled={processing || loadingPreview || !prorrateo}
            >
              {processing ? tc('processing') : t('downgradeModal.confirm')}
            </button>
          )}
          <button className="btn-cancel-back" onClick={onClose} disabled={processing}>
            {blocked ? t('downgradeModal.understood') : t('downgradeModal.back')}
          </button>
        </div>
      </div>
    </div>
  );
}
